import ITourCategory from 'interfaces/ITourCategory';
import RestService from './RestService';

export default class TourCategoryService extends RestService<ITourCategory> {
  constructor() {
    super('tour-categories');
  }
}
